import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Bitbucket extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M14.5241657,15.5199415 L9.51902664,15.5199415 L8.16414785,8.44160919 L15.7344815,8.44160919 L14.5241657,15.5199415 Z M0.780189684,1.20896395 C0.351563484,1.20408893 0.00468751312,1.54140238 0,1.97002858 C0,2.0133412 0.00468751312,2.05665382 0.00956252676,2.10484146 L3.27507167,21.9191469 C3.3568219,22.4201483 3.79032311,22.7861493 4.29619952,22.7910244 L19.9539933,22.7910244 C20.3344319,22.7958994 20.6619953,22.5212111 20.7246205,22.1456475 L23.9901296,2.10971647 C24.0574423,1.6906528 23.773379,1.29577669 23.3543154,1.2282765 C23.3110027,1.22340149 23.2675026,1.21871398 23.2195025,1.21871398 L0.780189684,1.20896395 Z" />
      </svg>
    );
  }
}

export default Bitbucket;
